import { Badge } from '@cimpress-ui/react';
import { IconCheckCircleFill, IconCloseCircle } from '@cimpress-ui/react/icons';

export const IDPStatus = ({ isValid }: { isValid: boolean }) => {
  if (isValid) {
    return (
      <Badge data-cim-style-root tone="info" size="large" iconStart={<IconCheckCircleFill tone="success" />}>
        IDP
      </Badge>
    );
  }

  return (
    <Badge data-cim-style-root tone="critical" size="large" iconStart={<IconCloseCircle tone="critical" />}>
      IDP
    </Badge>
  );
};
